// extracted by mini-css-extract-plugin
export default {"listItem":"iconicList_listItem__EblHU"};